var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("top-bar"),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "py-2", attrs: { id: "main-container", fluid: false } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }